import { api } from 'app/api/common';
import { AuthInfoMapper } from 'app/pages/auth/mapper/auth-info-mapper';
import { authenticationService } from 'app/api/service/authentication-service';

export class AuthService {
    public static readonly fetchAccessToken = (code: string, codeVerifier: string) =>
        authenticationService.fetchAccessToken(code, codeVerifier).then(AuthInfoMapper.toAuthInfo);

    public static readonly logout = async (): Promise<void> => api.authController.logout();
}
